export const cleanPhoneNumber = (phone: string): string => {
  // Strip any user formatting from phone numbers because we
  // handle how to display this on the front-end.
  // e.g., "(123) 456-7890" -> "1234567890"
  phone = phone.replace(/[^\d]/g, '');

  if (phone.length > 10) {
    phone = phone.substring(0, 10);
  }

  return phone;
};

export const formatPhoneNumber = (phone: string) => {
  if (typeof phone === 'undefined') {
    return '';
  }

  let phoneNumber = cleanPhoneNumber(phone);
  const phoneLength = phoneNumber.length;

  // Check the length of the phone number and add appropriate masking based on length.
  if (phoneLength === 10) {
    phoneNumber = `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 10)}`;
  } else if (phoneLength > 6) {
    phoneNumber = `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(
      6,
      phoneLength,
    )}`;
  } else if (phoneLength > 3) {
    phoneNumber = `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, phoneLength)}`;
  } else if (phoneLength > 0) {
    phoneNumber = `(${phoneNumber.substring(0, phoneLength)}`;
  }

  return phoneNumber;
};
